module.exports = __webpack_public_path__ + "static/img/4392_phase_function_Paper_Points.2e78abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4392_phase_function_Paper_Points.png
// module id = 5EZ2
// module chunks = 0